module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_8003.a1db9ca5.png";